export const logo = 'favicon.png';

export const TITLE_LIMIT = 30;
export const TEXT_LIMIT = 150;